import React from "react";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../appRedux/ducks/snackbar";

import "./WSContactSupport.scss";
import { Tooltip } from "@material-ui/core";
import EmailIcon from "@mui/icons-material/Email";

const WSContactSupport = ({ isMobile = false }) => {
  const dispatch = useDispatch();
  const emailAddress = "support@tradealgo.com";

  const handleClick = (_e) => {
    // Copy email to clipboard
    navigator.clipboard
      .writeText(emailAddress)
      .then(() => {
        // Show success notification
        dispatch(
          showSnackbar("Email address copied to clipboard!", {
            variant: "success",
            autoHideDuration: 3000,
          }),
        );
      })
      .catch((err) => {
        console.error("Failed to copy email: ", err);
      });

    // The default mailto behavior will still work
  };

  return (
    <a
      href={`mailto:${emailAddress}`}
      className={`ws-contact-support-button ${isMobile ? "ws-contact-support-button--mobile" : ""}`}
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      <Tooltip
        title="Need assistance? Reach out to our Wealth Series team for priority support at support@tradealgo.com"
        placement="bottom"
        arrow
      >
        <div className="ws-contact-support-button__wrapper">
          <EmailIcon />
          <span>Contact Support</span>
          <span className="ws-contact-support-chip">Priority</span>
        </div>
      </Tooltip>
    </a>
  );
};

export default WSContactSupport;
